module.exports = __webpack_public_path__ + "media/tags/smartsearch/loading-01217de6bf41aa4dd8243e042ee08b4f.gif";